import { render, staticRenderFns } from "./VM.vue?vue&type=template&id=2609a866&"
import script from "./VM.vue?vue&type=script&lang=js&"
export * from "./VM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports